import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState } from 'recompose'
import { authenticateByCredentials, forgotPassword } from 'actions/Auth'
import withForms from 'utils/hocs/withForms'
import LoginView from 'components/login/Login'
import history from 'utils/history'
import Swal from 'sweetalert2'

export function mapStateToProps(state) {
  const {
    isAuthenticating = false,
    errorMessage = null,
  } = state.root.auth || {}

  return {
    isAuthenticating,
    errorMessage,
  }
}

const mapDispatchToProps = dispatch => ({
  loginWithCredentials: bindActionCreators(authenticateByCredentials, dispatch),
  forgotPassword: bindActionCreators(forgotPassword, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withForms(),
  withState('errMessage', 'setErrMessage', ''),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isLogin', 'setIsLogin', true),
  withState('isSubmitForgot', 'setIsSubmitForgot', false),
  withHandlers({
    handleSwitchLogin: props => () => {
      props.setIsLogin(!props.isLogin)
      props.setErrMessage('')
      props.setForm({ email: '', password: '' })
    },
    onSubmitForgot: props => (event) => {
      event.preventDefault()
      props.setIsSubmitForgot(true)
      props.forgotPassword({ email: props.form.email })
        .then(() => {
          props.setIsSubmitForgot(false)
          props.setForm({ email: '' });
          Swal.fire(
            'Tautan untuk mereset password anda sudah dikirim',
            'Silahkan cek Email Anda',
            'success',
          ).then(() => {
            history.push('/')
          })
        })
        .catch((err) => {
          props.setErrMessage(err)
          props.setIsSubmitForgot(false)
        })
    },
    onSubmit: props => (event) => {
      event.preventDefault()
      props.setIsSubmit(true)
      props.loginWithCredentials(props.form)
        .then(() => {
        // props.setIsSubmit(false)
        // history.push('/dashboard')
        })
        .catch((err) => {
          props.setErrMessage(err)
          props.setIsSubmit(false)
        })
    },
  }),
)(LoginView)
